import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  axiosInstance,
  axiosNewApiInstance,
  partsApiInstance,
} from "../../services/api.js";

//! EMPLOYEE = USERS

// Get all employees data +
export const getAllEmployees = createAsyncThunk(
  "settings/getAllEmployees",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/users/`);
      // console.log("getAllEmployees", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get all mechanics +
export const getAllMechanics = createAsyncThunk(
  "settings/getAllMechanics",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/users/mechanics`);
      console.log("getAllMechanics", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create employee / user +
export const createEmployee = createAsyncThunk(
  "settings/createEmployee",
  async (employeeData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/users/`,
        employeeData
      );
      console.log("createEmployee", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get data for employee create form +
export const getEmployeeFormData = createAsyncThunk(
  "settings/getEmployeeFormData",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/users/form-init-data`
      );
      console.log("getEmployeeFormData", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Permissions List +
export const getPermissionsList = createAsyncThunk(
  "settings/getPermissionsList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/users/permissions`
      );

      console.log("getPermissionsList", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get permissions list by role +
export const getPermissionsListByRole = createAsyncThunk(
  "settings/getPermissionsListByRole",
  async (role_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/users/roles/${role_id}/permissions`
      );
      console.log("getPermissionsListByRole", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update employee data +
export const updateEmployeeData = createAsyncThunk(
  "settings/updateEmployeeData",
  async (employeeDataToUpdate, thunkAPI) => {
    try {
      const { employee_id, ...dataToUpdate } = employeeDataToUpdate;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/users/${employee_id}`,
        dataToUpdate
      );
      console.log("updateEmployeeData", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete employee +
export const deleteEmployee = createAsyncThunk(
  "settings/deleteEmployee",
  async (employee_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/users/${employee_id}`
      );
      console.log("deleteEmployee", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update employee status +
export const updateEmployeeStatus = createAsyncThunk(
  "settings/updateEmployeeStatus",
  async (newStatus, thunkAPI) => {
    try {
      const { employee_id, status } = newStatus;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/users/${employee_id}/status?status=${status}`,
        null
      );
      console.log("updateEmployeeStatus", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

//  Add debts to employees +
export const addsDebtToEmployee = createAsyncThunk(
  "settings/addsDebtToEmployee",
  async (debtData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/users/debt/bulk`,
        debtData
      );
      console.log("addsDebtToEmployee", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Add employees category +
export const addEmployeeCategory = createAsyncThunk(
  "settings/addEmployeeCategory",
  async (categoryData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/users/company-role-categories`,
        categoryData
      );
      console.log("addEmployeeCategory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Add employees roles +
export const addEmployeeRole = createAsyncThunk(
  "settings/addEmployeeRole",
  async (roleData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/users/company-roles`,
        roleData
      );
      console.log("addEmployeeRole", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//! SUPPLIER

// Get all suppliers list +
export const getAllSuppliers = createAsyncThunk(
  "settings/getAllSuppliers",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/suppliers/`);
      console.log("getAllSuppliers", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get supplier warehouses +
export const getSupplierWarehouses = createAsyncThunk(
  "settings/getSupplierWarehouses",
  async (supplier_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/suppliers/warehouses?supplier_id=${supplier_id}`
      );
      console.log("getSupplierWarehouses", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create supplier +
export const createSupplier = createAsyncThunk(
  "settings/createSupplier",
  async (supplierData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/suppliers/`,
        supplierData
      );
      console.log("createSupplier", response.data);
      console.log("Supplier ID from response:", response.data?.id);
      return response.data;
    } catch (error) {
      console.error("Error response:", error.response?.data);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// update supplier +
export const updateSupplierData = createAsyncThunk(
  "settings/updateSupplierData",
  async (employeeDataToUpdate, thunkAPI) => {
    try {
      const { supplier_id, ...dataToUpdate } = employeeDataToUpdate;

      // Make the API request
      const response = await axiosNewApiInstance.patch(
        `/api/v1/suppliers/${supplier_id}`,
        dataToUpdate
      );

      console.log("updateSupplierData", response.data);
      return response.data;
    } catch (error) {
      console.error("Error during updateSupplierData:", {
        message: error.message,
        code: error.code,
        config: error.config,
        response: error.response
          ? {
              status: error.response.status,
              data: error.response.data,
              headers: error.response.headers,
            }
          : null,
      });
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update supplier warehouses +
export const updateSupplierWarehouses = createAsyncThunk(
  "settings/updateSupplierWarehouses",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/suppliers/warehouses`,
        payload
      );
      console.log("updateSupplierWarehouses", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete supplier +
export const deleteSupplier = createAsyncThunk(
  "settings/deleteSupplier",
  async (supplier_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/suppliers/${supplier_id}`
      );
      console.log("deleteSupplier", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Upload distributors list from Excel file +
export const uploadDistributorsFromExcel = createAsyncThunk(
  "settings/uploadDistributorsFromExcel",
  async (formData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/suppliers/import`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("uploadDistributorsFromExcel", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Add debts to suppliers +
export const addsDebtToSupplier = createAsyncThunk(
  "settings/addsDebtToSupplier",
  async (debtData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/suppliers/debt/bulk`,
        debtData
      );
      console.log("addsDebtToSupplier", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Test supplier connection
export const testSupplierConnection = createAsyncThunk(
  "settings/testSupplierConnection",
  async (connectionData, thunkAPI) => {
    try {
      const response = await partsApiInstance.post(
        `/suppliers/test-connection`,
        connectionData
      );
      console.log("testSupplierConnection", response.data);
      return response.data;
    } catch (error) {
      console.error("Error response:", error.response?.data);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

//! SCHEDULE

// // Get work schedule
// export const getWorkSchedule = createAsyncThunk(
//   "settings/getWorkSchedule",
//   async (_, thunkAPI) => {
//     const state = thunkAPI.getState();
//     const serviceId = state.service.selectedServiceInSettingsId;
//     try {
//       const response = await axiosInstance.get(`/set/get_work_schedule/`, {
//         headers: {
//           // "X-Api-Key": "YA7NxysJ",
//           "company-id": serviceId,
//         },
//       });
//       console.log("getWorkSchedule", response.data);

//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue({
//         status: error.response?.status,
//         message: error.message,
//         details: error.response?.data.detail, // Залишаємо лише необхідні дані
//       });
//     }
//   }
// );

// // Update work schedule
// export const updateWorkSchedule = createAsyncThunk(
//   "settings/updateWorkSchedule",
//   async (workScheduleData, thunkAPI) => {
//     const state = thunkAPI.getState();
//     const serviceId = state.service.selectedServiceInSettingsId;
//     try {
//       const response = await axiosInstance.patch(
//         `/set/set_work_schedule/`,
//         workScheduleData,
//         {
//           headers: {
//             // "X-Api-Key": "YA7NxysJ",
//             "company-id": serviceId,
//           },
//         }
//       );
//       console.log("updateWorkSchedule", response.data);

//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue({
//         status: error.response?.status,
//         message: error.message,
//         details: error.response?.data.detail, // Залишаємо лише необхідні дані
//       });
//     }
//   }
// );

//! POSTS

// Get list of all posts +
export const getPosts = createAsyncThunk(
  "settings/getPosts",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/posts/`);
      console.log("getPosts", response.data);

      return response.data;
    } catch (error) {
      console.log("error in operation", error);

      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create new post +
export const createPost = createAsyncThunk(
  "settings/createPost",
  async (postData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/posts/`,
        postData
      );
      console.log("createPost", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update post data +
export const updatePostData = createAsyncThunk(
  "settings/updatePostData",
  async (postDataToUpdate, thunkAPI) => {
    try {
      const { post_id, ...dataToUpdate } = postDataToUpdate;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/posts/${post_id}`,
        dataToUpdate
      );
      console.log("updatePostData", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete post +
export const deletePost = createAsyncThunk(
  "settings/deletePost",
  async (post_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/posts/${post_id}`
      );
      console.log("deletePost", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

//! PRICE PART

// Get categories and services for PricePart +
export const getPartsPrices = createAsyncThunk(
  "settings/getPartsPrices",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/parts_services/tree`
      );
      console.log("getPartsPrices", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get categories and services for Other Services Part +
export const getOtherServicesPrices = createAsyncThunk(
  "settings/getOtherServicesPrices",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/parts_services/other_services/tree`
      );
      console.log("getOtherServicesPrices", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update Parts category or service price +
export const updatePartsServiceOrCategory = createAsyncThunk(
  "settings/updatePartsServiceOrCategory",
  async (newData, thunkAPI) => {
    const { id, ...dataToUpdate } = newData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/parts_services/${id}`,
        dataToUpdate
      );
      console.log("updatePartsServiceOrCategory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update Other services category or service price +
export const updateOtherServicesCategoryOrService = createAsyncThunk(
  "settings/updateOtherServicesCategoryOrService",
  async (newData, thunkAPI) => {
    const { id, ...dataToUpdate } = newData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/parts_services/other_services/${id}`,
        dataToUpdate
      );
      console.log("updateOtherServicesCategoryOrService", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create parts price category +
export const createPartsPriceCategory = createAsyncThunk(
  "settings/createPartsPriceCategory",
  async (data, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/parts_services/categories`,
        data
      );
      console.log("createPartsPriceCategory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create other services price category +
export const createOtherServicesPriceCategory = createAsyncThunk(
  "settings/createOtherServicesPriceCategory",
  async (data, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/parts_services/other_services/categories`,
        data
      );
      console.log("createOtherServicesPriceCategory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create parts service +
export const createPartsService = createAsyncThunk(
  "settings/createPartsService",
  async (newService, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/parts_services/`,
        newService
      );
      console.log("createPartsService", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create Other services service +
export const createOtherServicesService = createAsyncThunk(
  "settings/createOtherServicesService",
  async (newService, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/parts_services/other_services/`,
        newService
      );
      console.log("createOtherServicesService", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete service or category +
export const deletePartsServiceOrCategory = createAsyncThunk(
  "settings/deletePartsServiceOrCategory",
  async (id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/parts_services/${id}`
      );
      console.log("deletePartsServiceOrCategory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete Other service or category +
export const deleteOtherServiceOrCategory = createAsyncThunk(
  "settings/deleteOtherServiceOrCategory",
  async (id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/parts_services/other_services/${id}`
      );
      console.log("deleteOtherServiceOrCategory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get data for ServicesPrices (left side) +
export const getServicesPrices = createAsyncThunk(
  "settings/getServicesPrices",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/services/tree`);
      console.log("getServicesPrices", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Add service subcategory (left side) +
export const addServicesSubcategory = createAsyncThunk(
  "settings/addServicesSubcategory",
  async (newCategory, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/services/`,
        newCategory
      );
      console.log("addServicesSubcategory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete subcategory or category (left side) +
export const deleteDiagnosticCategory = createAsyncThunk(
  "settings/deleteDiagnosticCategory",
  async (service_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/services/${service_id}`
      );
      console.log("deleteDiagnosticCategory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update subcategory or category (left side) +
export const updateDiagnosticCategory = createAsyncThunk(
  "settings/updateDiagnosticCategory",
  async (newData, thunkAPI) => {
    console.log("newData in operation:", newData);
    const { id, ...updatedData } = newData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/services/${id}`,
        updatedData
      );
      console.log("updateDiagnosticCategory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Upload other services prices from file +
export const uploadOtherServicesPrices = createAsyncThunk(
  "settings/uploadOtherServicesPrices",
  async (fileData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/parts_services/other_services/upload_prices`,
        fileData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("uploadOtherServicesPrices", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Upload parts prices from file +
export const uploadPartsPrices = createAsyncThunk(
  "settings/uploadPartsPrices",
  async (fileData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/parts_services/upload_prices`,
        fileData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("uploadPartsPrices", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

//! RATING

// Get Ratings List
export const getRatings = createAsyncThunk(
  "settings/getRatings",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.service.selectedServiceInSettingsId;
    try {
      const response = await axiosInstance.get(`/set/ratings_all/`, {
        headers: {
          // "X-Api-Key": "YA7NxysJ",
          "company-id": serviceId,
        },
      });
      console.log("getRatings", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

//! MARKUP

// Get all markups +
export const getAllMarkups = createAsyncThunk(
  "settings/getAllMarkups",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/markup/`);
      console.log("getAllMarkups", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create Markup +
export const createMarkup = createAsyncThunk(
  "settings/createMarkup",
  async (newMarkup, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/markup/`,
        newMarkup
      );
      console.log("createMarkup", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update Fixed Markup +
export const updateFixedMarkup = createAsyncThunk(
  "settings/updateFixedMarkup",
  async (updatedMarkup, thunkAPI) => {
    try {
      const { markup_id, ...markup } = updatedMarkup;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/markup/${markup_id}`,
        markup
      );
      console.log("updateFixedMarkup", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete Markup +
export const deleteMarkup = createAsyncThunk(
  "settings/deleteMarkup",
  async (markup_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/markup/${markup_id}`
      );
      console.log("deleteMarkup", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

//! Cash register

// Get All Cash Registers +
export const getAllCashRegisters = createAsyncThunk(
  "settings/getAllCashRegisters",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/cash-registers/`);
      console.log("getAllCashRegisters", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create cash register +
export const createCashRegister = createAsyncThunk(
  "settings/createCashRegister",
  async (cashRegisterData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/cash-registers/`,
        cashRegisterData
      );
      console.log("createCashRegister", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update cash register +
export const updateCashRegister = createAsyncThunk(
  "settings/updateCashRegister",
  async (updatedCashRegister, thunkAPI) => {
    try {
      const { cash_register_id, ...cashRegister } = updatedCashRegister;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/cash-registers/${cash_register_id}`,
        cashRegister
      );
      console.log("updateCashRegister", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete Cash Register +
export const deleteCashRegister = createAsyncThunk(
  "settings/deleteCashRegister",
  async (cash_register_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/cash-registers/${cash_register_id}`
      );
      console.log("deleteCashRegister", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// !Registration of a new service
export const registerNewService = createAsyncThunk(
  "settings/registerNewService",
  async (serviceData, thunkAPI) => {
    // const state = thunkAPI.getState();
    // const serviceId = state.service.selectedServiceInSettingsId;
    try {
      const response = await axiosInstance.post(
        `/set/registration_services`,
        serviceData,
        {
          headers: {
            // "X-Api-Key": "YA7NxysJ",
            // "company-id": serviceId,
          },
        }
      );
      console.log("registerNewService", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! API Integration

// Get integration
export const getIntegration = createAsyncThunk(
  "settings/getIntegration",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/integrations/`);
      console.log("getIntegration", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create integration
export const createIntegration = createAsyncThunk(
  "settings/createIntegration",
  async (integrationData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/integrations/`,
        integrationData
      );
      console.log("createIntegration", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update integration
export const updateIntegration = createAsyncThunk(
  "settings/updateIntegration",
  async (integrationData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/integrations/`,
        integrationData
      );
      console.log("updateIntegration", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete integration
export const deleteIntegration = createAsyncThunk(
  "settings/deleteIntegration",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/integrations/`
      );
      console.log("deleteIntegration", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Test integration
export const testIntegration = createAsyncThunk(
  "settings/testIntegration",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/integrations/test`
      );
      console.log("testIntegration", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Reset integration API key
export const resetIntegrationApiKey = createAsyncThunk(
  "settings/resetIntegrationApiKey",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/integrations/api-key/rotate`
      );
      console.log("resetIntegrationApiKey", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! LICENSE

// get license +
export const getLicense = createAsyncThunk(
  "settings/getLicense",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/licenses/current`
      );
      console.log("getLicense", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
 
// request license key +
export const requestLicenseKey = createAsyncThunk(
  "settings/requestLicenseKey",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/licenses/request`
      );
      console.log("requestLicenseKey", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! RECORDS

// Delete record
export const deleteRecord = createAsyncThunk(
  "settings/deleteRecord",
  async (recordId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/records/${recordId}`
      );
      console.log("deleteRecord", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete all records
export const deleteAllRecords = createAsyncThunk(
  "settings/deleteAllRecords",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(`/api/v1/records`, {
        params: { confirm: true, with_vehicles: true },
      });
      console.log("deleteAllRecords", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);